// extracted by mini-css-extract-plugin
module.exports = {"hint":"ParameterInputExpanded_hint_LEUNi","information":"ParameterInputExpanded_information_bmM_4"};